module.exports = __webpack_public_path__ + "static/media/penelope_spanish_us.923b23f0.mp3";